import { Progress } from "antd"
import { Skeleton, Space, Text } from "components/common"

const ScoringBreakdown = ({
  scoringData,
  isFetching,
  scoreLabel,
  isAvgScoreClickable,
  onAvgScoreClick,
  progressProps = {},
  resolveStrokeColor,
}) => {
  const avgScore = scoringData?.avgScore ?? 0
  const metrics = scoringData?.metrics ?? []

  if (isFetching) {
    return (
      <div className="p-16">
        <Skeleton type="antparagraph" active paragraph={{ rows: 6, width: ["80%", "60%", "70%", "50%", "90%"] }} />
      </div>
    )
  }

  return (
    <div className="p-1" style={{ minHeight: 320 }}>
      <Space direction="vertical" size={15} style={{ width: "100%" }}>
        <div style={{ textAlign: "right" }}>
          <Text style={{ fontSize: 14, color: "#777" }}>
            {scoreLabel}:{" "}
            {isAvgScoreClickable ? (
              <Text style={{ color: "#00A3E0", fontSize: 14, fontWeight: 600, cursor: "pointer" }} onClick={onAvgScoreClick}>
                {Math.round(avgScore)}%
              </Text>
            ) : (
              <Text style={{ color: "#00A3E0", fontSize: 14, fontWeight: 600 }}>{Math.round(avgScore)}%</Text>
            )}
          </Text>
        </div>

        {metrics.map((item, idx) => (
          <div key={idx}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
              <Text style={{ fontSize: 14, color: "#666" }}>{item.name}</Text>
              <Text style={{ fontSize: 14, fontWeight: 600 }}>{Math.round(item.score ?? 0)}%</Text>
            </div>

            <Progress
              {...progressProps}
              percent={Math.round(item.score ?? 0)}
              showInfo={progressProps.showInfo ?? false}
              strokeColor={resolveStrokeColor(item.score ?? 0)}
              trailColor={progressProps.trailColor ?? "#F2F2F2"}
              strokeLinecap={progressProps.strokeLinecap ?? "round"}
            />
          </div>
        ))}
      </Space>
    </div>
  )
}

export default ScoringBreakdown
